// "You've used your free style" — friendly upsell shown to free Android
// users when their lifetime allowance is exhausted. Single CTA opens the
// existing BuyCreditsDialog paywall.
import { Sparkles } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  onSeePlans: () => void;
}

export const FreeTrialUsedDialog = ({ open, onOpenChange, onSeePlans }: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-primary to-primary/60 text-primary-foreground">
          <Sparkles className="h-7 w-7" />
        </div>
        <DialogTitle className="text-center">You've used your free style ✨</DialogTitle>
        <DialogDescription className="text-center">
          Loved styling with FitAura? Grab a credit pack to keep generating —
          the First Try pack is just ₹49 for 5 credits.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="flex flex-col gap-2 sm:flex-col">
        <Button onClick={onSeePlans} size="lg" className="w-full">
          See plans
        </Button>
        <Button variant="ghost" onClick={() => onOpenChange(false)} className="w-full">
          Maybe later
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
